import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class TableScroll extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.tableWrappers = $('.table-wrapper');
    this.start();
    return super.initialize();
  }

  start() {
    this.tableWrappers.each((i, wrapper) => {
      this.trackWrapper(
        $(wrapper)
      );
    });
  }

  trackWrapper(wrapper) {

    let container = wrapper.find('.table-container'),
        table = wrapper.find('table'),
        overlay = wrapper.find('.table-scrolling-overlay'),
        difference = 0,
        isOverflowed = false;

    let updateOffsetState = function() {
      difference = table.outerWidth() - wrapper.outerWidth();
      isOverflowed = difference > 0;
      container.trigger('scroll');

      container.unbind('DOMMouseScroll mousewheel');
      if (isOverflowed) {
        container.hScroll(40);
        overlay.removeClass('is-hidden');
        setTimeout(function(){
          overlay.addClass('is-hidden');
        }, 1200);
      }
    };

    container.on('scroll', (event) => {
      let leftOffset = $(event.currentTarget).scrollLeft(),
          rightOffset = (difference - leftOffset);

      if (isOverflowed) {

        if (leftOffset > 10 && !wrapper.hasClass('has-shadow-left')) wrapper.addClass('has-shadow-left');
        else if (leftOffset <= 10 && wrapper.hasClass('has-shadow-left')) wrapper.removeClass('has-shadow-left');

        if (rightOffset > 10 && !wrapper.hasClass('has-shadow-right')) wrapper.addClass('has-shadow-right');
        else if (rightOffset <= 10 && wrapper.hasClass('has-shadow-right')) wrapper.removeClass('has-shadow-right');

      } else {
        wrapper.removeClass('has-shadow-left has-shadow-right');
      }

    });

    this.App.Events.subscribe('window.orientationchange', updateOffsetState);
    this.App.Events.subscribe('window.resize', updateOffsetState);

    updateOffsetState();

  }

}